<!-- 模块- 待核销-->
<template>
<div>
  <van-pull-refresh v-model="down_loading" @refresh="pulldown">
    <span v-if="data.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">

        <!-- 商品列表 -->
        <div class="goods" v-for="(item, index) in data" :key="index" @click="show_ma(item)">
          <!-- 积分商品左边图片 -->
          <van-image v-if="item.img_data.length>0" width="25%" :src="item.img_data[0].url" />
          <van-image v-else style="width: 25%;height: 0;padding-bottom: 25%;" src="">
            <template v-slot:error>暂无封面</template>
          </van-image>
          <!-- 积分商品右边内容说明 -->
          <van-row class="goods_info" style="width:60%">
            <van-col span="24">{{ item.name }}</van-col>
            <van-col span="24" class="yxq">
              <span style="color:#9e9e9e;font-size:12px">{{ item.start_time }} 至 {{ item.end_time }}</span>
              <icon class="icon" name="erweima"></icon>
            </van-col>
          </van-row>
        </div>

      </van-list>
    </span>
    <van-empty v-else description="暂无记录" />
  </van-pull-refresh>
  <!-- 出示二维码 -->
  <van-popup v-model="showNum" position="bottom" round :style="{ height: '80%' }">
    <div class="popup_tit">
      <span>扫码核销</span>
      <van-button type="default" round size="small" @click="showNum = false">取 消</van-button>
    </div>
    <div class="van-sku-row van-hairline--bottom">
      <div class="show">
        <div id="qrCode" style="margin-top:10px"></div>
        <span style="font-size:28px">{{code}}</span>
      </div>
    </div>

    <div class="van-sku-row">
      <div class="van-sku-row__title">可用站点：<span style="color: #c1c1c1;font-size: 12px;">（点击查看详细信息）</span></div>
      <span class="van-sku-row__item" v-for="(item, index) in ky_site" :key="index" >
        <div class="van-sku-row__item-name" @click="go_detail(sel_site[index])">{{item}}</div>
      </span>
    </div>
    <div class="van-sku-row">
      <div class="van-sku-row__title">兑换有效期：</div>
      <span class="van-sku-row__item">
        <div class="van-sku-row__item-name">{{dhTime}}</div>
      </span>
    </div>
  </van-popup>
  <siteDetails ref="details" />
</div>

</template>

<style lang="scss" scoped>
  .goods {
    position: relative;
    display: flex;
    justify-content: space-around;
    margin:0 0 15px;
    padding:15px 5px;
    background:#fff;
  }
  .goods_info{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .van-list{
    padding: 10px;
  }
  .icon {
    width: 35px;
    height: 35px;
  }
  .show{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
  }
  .yxq{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
<script>
import siteDetails from '@/components/site/site_details'

import QRCode from 'qrcodejs2'

export default {
  components: {siteDetails},
  data () {
    return {
      site: [],
      showNum: false,
      code: '',
      dhTime: '',
      page: 1,
      size: 15,
      data: [],
      sel_site: {},
      ky_site: [],
      loading: false,
      finished: false,
      down_loading: false
    }
  },
  created () {
    this.get_data()
    this.get_site()
  },
  methods: {

    // 获取数据
    get_data () {
      let data = {
        page: this.page,
        size: this.size,
        type: 1,
        status: 1
      }
      this.ax(this, 'wx_user_coupons', data, (res) => {
        if (res.err_num === 0) {
          this.page = res.data.page
          this.data = this.data.concat(res.data.data)

          this.loading = false
          this.down_loading = false

          // 判断是否还有更多
          if (res.data.data.length < this.size) {
            this.finished = true
          }
        }
      })
    },
    // 上拉加载更多
    loadMore () {
      this.page += 1
      this.get_data()
    },
    // 下拉刷新
    pulldown () {
      this.finished = false
      this.page = 1
      this.data = []
      this.get_data()
    },
    // 生成二维码
    qrcode (code) {
      document.getElementById('qrCode').innerHTML = ''
      let qrcode = new QRCode('qrCode', { // eslint-disable-line no-unused-vars
        text: code,
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    // 核销二维码
    show_ma (goods) {
      this.showNum = true
      this.code = goods.num

      this.ky_site = goods.site_data.split(' | ')
      this.sel_site = goods.s_id
      this.dhTime = goods.start_time + ' 至 ' + goods.end_time
      setTimeout(() => {
        this.qrcode(goods.num)
      }, 0)
    },

    // 获取油站
    get_site () {
      this.ax(this, 'sel_site', {set_price: false}, (res) => {
        if (res.err_num === 0) {
          this.site = res.data
        }
      })
    },

    // 点击跳转站点详情
    go_detail (id) {
      let site = null
      this.site.forEach((item) => {
        if (item.s_id === id) {
          site = item
        }
      })
      if (site !== null) {
        this.$refs.details.show(site)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/write_off.vue